import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['toast']

  connect() {
    const id = document.getElementById('theToast')
    const toast = new bootstrap.Toast(id)
    toast.show()
  }
}
